import React from 'react';
import AniLink from "gatsby-plugin-transition-link/AniLink"

const MobileSecondaryLink = ({ item }) => {
  return (
    <AniLink className='secondary-link' fade to={item.uri}>{item.label}</AniLink>
  )
}

export default MobileSecondaryLink;